import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import {
  type Proposal,
  schemaApprovalItems,
  withSchemaApproval,
} from '@/services/api/structuredIngest'

export function SchemaApproval({
  recipe,
  disabled,
  onChange,
}: {
  recipe: Proposal
  disabled: boolean
  onChange: (recipe: Proposal) => void
}) {
  const { t } = useTranslation()
  const id = useId()
  const items = schemaApprovalItems(recipe)
  if (!items.length) return null
  const approved = items.filter(item => item.accept_new_type).length
  const checked = approved === items.length ? true : approved > 0 ? 'indeterminate' : false

  return (
    <div className="flex w-full items-start gap-2.5">
      <Checkbox
        id={id}
        className="mt-0.5"
        checked={checked}
        disabled={disabled}
        aria-describedby={`${id}-description`}
        onCheckedChange={value => onChange(withSchemaApproval(recipe, value === true))}
      />
      <div className="flex flex-col gap-1">
        <Label htmlFor={id}>{t('tableMapping.review.approveAll')}</Label>
        <p id={`${id}-description`} className="text-xs text-muted-foreground">
          {t('tableMapping.review.approveAllDetail', { approved, total: items.length })}
        </p>
      </div>
    </div>
  )
}
